export const RAX_CHUNK_NAME = {
  ClassDidMountBegin: 'RaxComponentClassDidMountBegin',
  ClassDidMountContent: 'RaxComponentClassDidMountContent',
  ClassDidMountEnd: 'RaxComponentClassDidMountEnd',
  ClassWillUnmountBegin: 'RaxComponentClassWillUnmountBegin',
  ClassWillUnmountContent: 'RaxComponentClassWillUnmountContent',
  ClassWillUnmountEnd: 'RaxComponentClassWillUnmountEnd',
  ClassRenderBegin: 'RaxComponentClassRenderBegin',
  ClassRenderPre: 'RaxComponentClassRenderPre',
  ClassRenderJSX: 'RaxComponentClassRenderJSX',
  ClassRenderEnd: 'RaxComponentClassRenderEnd',
  MethodsBegin: 'RaxComponentMethodsBegin',
  MethodsContent: 'RaxComponentMethodsContent',
  MethodsEnd: 'RaxComponentMethodsEnd',
  LifeCyclesBegin: 'RaxComponentLifeCyclesBegin',
  LifeCyclesContent: 'RaxComponentLifeCyclesContent',
  LifeCyclesEnd: 'RaxComponentLifeCyclesEnd',
};
